export default __webpack_public_path__ + "static/media/inActiveHeaderHome.aea5583a.svg";